import { HelpLayout } from "@/components/help-layout";
import { subText } from "@/components/table";
import { type HelpTermId, TERMS } from "@/lib/help";

/**
 * Every term the screens use, with the consequence where there is one. The
 * inline term popovers link here, so each entry carries the anchor `term-<id>`.
 */
export function GlossaryHelpPage() {
  const ids = Object.keys(TERMS) as HelpTermId[];
  return (
    <HelpLayout
      title="Glossary"
      intro="The words the screens use, defined once. The dotted terms on the screens open the same definitions."
      sections={ids.map((id) => ({ id: `term-${id}`, title: TERMS[id].title }))}
    >
      <dl className="mt-6 space-y-5">
        {ids.map((id) => {
          const term = TERMS[id];
          return (
            <div key={id} id={`term-${id}`} className="scroll-mt-4">
              <dt className="text-fg text-sm font-medium">{term.title}</dt>
              <dd className={`${subText} mt-0.5 max-w-3xl`}>
                {term.body}
                {term.caution ? (
                  <span className="border-warning-border mt-1 block border-l-2 pl-2">
                    {term.caution}
                  </span>
                ) : null}
              </dd>
            </div>
          );
        })}
      </dl>
    </HelpLayout>
  );
}
